import { Link } from 'react-router-dom'

interface LoginButtonProps {
  mobile?: boolean
  onClick?: () => void
  className?: string
}

export function LoginButton({ mobile = false, onClick, className = '' }: LoginButtonProps) {
  if (mobile) {
    return (
      <Link to="/login" onClick={onClick} className={className}>
        <div className="block px-3 py-2 rounded-lg text-base font-medium text-neutral-700 hover:bg-neutral-100 cursor-pointer">
          Login
        </div>
      </Link>
    )
  }

  return (
    <Link to="/login" className={className}>
      <span className="text-sm font-medium text-neutral-700 hover:text-primary-600 transition-colors cursor-pointer">
        Login
      </span>
    </Link>
  )
}

